module.exports = __webpack_public_path__ + "img/CHANEL-01.aea0be63.png";